import { Component, OnDestroy, OnInit } from "@angular/core";
import {
  NbDialogService,
  NbMediaBreakpointsService,
  NbMenuService,
  NbSidebarService,
  NbThemeService,
} from "@nebular/theme";

import { LayoutService } from "../../../@core/utils";
import { map, takeUntil } from "rxjs/operators";
import { Observable, Subject } from "rxjs";
import { UserService } from "../../../@core/services/user.service";
import { Router } from "@angular/router";
import { DialogAuthLoginComponent } from "../../../@components/dialog-auth-login/dialog-auth-login.component";
import { DialogFeedbackComponent } from "../../../@components/dialog-feedback/dialog-feedback.component";

import Feedback from "../../../models/feedback.model";
import { ProfileService } from "../../../services/profile.service";

import { DialogNotificationsComponent } from "../../../@components/dialog-notifications/dialog-notifications.component";
import { UserData } from "../../../@core/data/users";

@Component({
  selector: "ngx-header",
  styleUrls: ["./header.component.scss"],
  templateUrl: "./header.component.html",
})
export class HeaderComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  user: any;
  userData: UserData = new UserData();
  uid = "";

  themes = [
    {
      value: "default",
      name: "Light",
    },
    {
      value: "dark",
      name: "Dark",
    },
    {
      value: "cosmic",
      name: "Cosmic",
    },
    {
      value: "corporate",
      name: "Corporate",
    },
  ];

  currentTheme = "default";

  userMenu = [
    { title: "Profile", link: "/profile" },
    { title: "Log out", link: "/auth/logout" },
  ];

  constructor(
    private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    public userService: UserService,
    private layoutService: LayoutService,
    private breakpointService: NbMediaBreakpointsService,
    protected router: Router,
    private dialogService: NbDialogService
  ) {}

  ngOnInit() {
    this.currentTheme = this.themeService.currentTheme;
    this.userData.notifications = 0;

    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: any) => {
        if (user && user.uid != this.uid) {
          this.user = user;
          this.userService
            .get(user.uid)
            .pipe(takeUntil(this.destroy$))
            .subscribe((data) => {
              this.userData = data;
            });
        } else {
          this.uid = "";
        }
      });

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService
      .onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$)
      )
      .subscribe(
        (isLessThanXl: boolean) => (this.userPictureOnly = isLessThanXl)
      );

    this.themeService
      .onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$)
      )
      .subscribe((themeName) => (this.currentTheme = themeName));

    //process auto collapse menu sidebar
    const { sm } = this.breakpointService.getBreakpointsMap();
    this.menuService
      .onItemSelect()
      .pipe(takeUntil(this.destroy$))
      .subscribe((event: { tag: string; item: any }) => {
        if (document.documentElement.clientWidth < sm) {
          this.sidebarService.collapse("menu-sidebar");
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, "menu-sidebar");
    this.layoutService.changeLayoutSize();

    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }

  login() {
    this.router.navigateByUrl(`/auth/login`);

    // this.dialogService
    //   .open(DialogAuthLoginComponent, {
    //     context: {
    //       mode: "header",
    //     },
    //     closeOnBackdropClick: false,
    //   })
    //   .onClose.subscribe((value) => {
    //     if (value) {
    //       console.log("HeaderComponent/login:", value);
    //       this.user = value;
    //     }
    //   });
  }

  feedback() {
    let fbNew = new Feedback();
    fbNew.category = "Góp ý";
    this.dialogService
      .open(DialogFeedbackComponent, {
        context: {
          header: "Tạo góp ý / báo lỗi",
          mode: "new",
          feedback: fbNew,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        this.router.navigateByUrl("/develop/feedback");
      });
  }

  notifications() {
    this.dialogService.open(DialogNotificationsComponent, {
      context: {},
      // hasBackdrop: false,
      // closeOnBackdropClick: false,
    });
  }
}
